
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetoajantaellora() {



    const cardData =
    {
        keyword: ' Pune to Ajanta Ellora Tour Package',
        heading: 'Prince Cabs:  Pune to Ajanta Ellora Tour Package',
        headingDescription: 'Prince Cabs offers a specially curated Pune to Ajanta Ellora Tour Package, perfect for history lovers, family vacations, educational trips, and cultural explorations. Our well-maintained sedans, SUVs, and luxury vehicles ensure a safe and comfortable ride to the world-famous Ajanta and Ellora Caves, UNESCO World Heritage Sites known for their ancient rock-cut architecture and sculptures. With professional drivers, flexible itineraries, and on-time service, we provide a seamless travel experience from Pune. Discover the heritage of Maharashtra with Prince Cabs’ trusted Ajanta Ellora tour package from Pune, designed for convenience, comfort, and affordability.',

        top: 'Top Places to Visit in Ajanta Ellora with Prince Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, dating back to the 2nd century BC, are a UNESCO World Heritage Site and a masterpiece of Buddhist art and architecture. Carved into a horseshoe-shaped gorge, the caves feature intricate paintings and frescoes depicting Jataka tales and the life of Buddha. The caves also house monasteries and prayer halls used by monks for meditation. Highlights include the Bodhisattva Padmapani and Avalokiteshvara paintings, which are globally acclaimed. Ajanta’s serene environment and artistic brilliance attract history lovers and spiritual seekers alike."
  },
  {
    "title": "Ellora Caves",
    "description": "The Ellora Caves, another UNESCO World Heritage Site, date from the 6th to 10th centuries and display a unique fusion of Hindu, Buddhist, and Jain monuments. Spread across 34 caves, Ellora reflects India’s religious harmony and cultural diversity. The site is best known for its magnificent Kailasa Temple, an engineering marvel carved from a single rock. Each cave features detailed sculptures, halls, and shrines showcasing incredible craftsmanship. Ellora stands as a symbol of devotion, art, and architectural brilliance. It is a must-visit for cultural travelers."
  },
  {
    "title": "Kailasa Temple (Cave 16, Ellora)",
    "description": "The Kailasa Temple at Ellora is one of the largest monolithic structures in the world, dedicated to Lord Shiva. Carved out of a single basalt rock, it features intricate carvings of gods, goddesses, and mythological scenes. Its scale and precision continue to amaze archaeologists and travelers. The temple’s courtyard, gopuram-style gateway, and life-sized elephants carved from stone add to its grandeur. Legends suggest that it was built in just a few years by the Rashtrakuta king Krishna I. It remains the jewel of Ellora’s caves."
  },
  {
    "title": "Buddhist Caves of Ajanta",
    "description": "Ajanta’s Buddhist caves include viharas (monasteries) and chaityas (prayer halls), reflecting deep spiritual practices of ancient monks. The caves were used for meditation and teaching Buddhist philosophy. Stunning murals showcase the compassionate life of Buddha and his previous births. Many caves still preserve original colors despite being over 2,000 years old. The sculptures of seated Buddhas exude serenity and grace. These caves highlight India’s unmatched ancient artistry and spiritual depth."
  },
  {
    "title": "Hindu Caves of Ellora",
    "description": "Ellora’s Hindu caves are celebrated for their elaborate depictions of Hindu deities and mythological tales. Apart from the Kailasa Temple, these caves feature shrines dedicated to Vishnu, Shiva, and Durga. Carvings like Ravana shaking Mount Kailash and stories from the Mahabharata and Ramayana are awe-inspiring. The architecture reflects the grandeur of the Rashtrakuta dynasty. These caves are both spiritually uplifting and visually stunning. They offer a glimpse into India’s devotion and artistic imagination."
  },
  {
    "title": "Jain Caves of Ellora",
    "description": "The Jain Caves at Ellora are smaller but equally intricate, showcasing exquisite carvings and detailed shrines. They highlight the principles of Jain philosophy and devotion to Tirthankaras. Notable caves include Cave 32, featuring stunning pillars and a shrine with Mahavira’s idol. The detailed ceiling and wall designs reflect exceptional craftsmanship. These caves emphasize non-violence, meditation, and asceticism. The Jain section adds spiritual diversity to Ellora’s grandeur."
  },
  {
    "title": "Ajanta View Point",
    "description": "Ajanta View Point, located on a hill opposite the caves, offers a panoramic aerial view of the entire cave complex. From here, visitors can see the horseshoe-shaped gorge and the beautifully lined caves along the cliff. The viewpoint provides an excellent spot for photography and appreciating the site’s natural setting. It is especially beautiful during monsoon when waterfalls cascade down the cliffs. The trek or drive to the viewpoint is worth the effort. It enhances the overall Ajanta experience by showing its scale and harmony with nature."
  },
  {
    "title": "Grishneshwar Temple",
    "description": "Located near Ellora, the Grishneshwar Temple is one of the 12 sacred Jyotirlingas dedicated to Lord Shiva. Built in red basalt stone, it showcases detailed carvings and a grand shikhara (spire). Pilgrims from across India visit to perform rituals and seek blessings. The temple is historically and spiritually significant, making it a popular stop for those visiting Ellora. Its vibrant atmosphere during festivals like Mahashivratri is captivating. The temple adds a sacred dimension to the Ellora region."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Situated close to Ellora, Daulatabad Fort is a 12th-century hill fortress renowned for its strong defenses and strategic importance. Built by the Yadava dynasty, it was later fortified by Delhi Sultanate rulers. Visitors explore its massive walls, secret passages, moats, and steep climbs. The panoramic views from the top are breathtaking. Its ingenious defense systems, including the ‘bat cave’ and deceptive pathways, fascinate history lovers. The fort is an adventurous addition to an Ajanta–Ellora trip."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Though lesser-known, the Aurangabad Caves near Ellora are a fascinating group of Buddhist shrines dating to the 6th–7th centuries. Carved into soft basalt rock, the caves feature impressive sculptures of Bodhisattvas and deities influenced by Tantric traditions. Their hilltop setting provides a peaceful environment with views of Aurangabad city. The caves are quieter compared to Ajanta and Ellora, offering a more intimate exploration. They are perfect for history buffs seeking hidden heritage gems. Together, they complete the region’s cave circuit."
  }
],


"services": [
    {
        "name": "Pune to Ajanta Caves Cab Service",
        "description": "Explore the majestic Ajanta Caves with our dedicated cab service from Pune. Our well-maintained vehicles and experienced drivers ensure a comfortable and safe journey to this UNESCO World Heritage site. Whether traveling solo, with family, or in a group, enjoy door-to-door service, flexible timings, and hassle-free booking for a memorable trip."
    },
    {
        "name": "Trip to Ajanta Ellora Caves from Pune",
        "description": "Plan your visit to both Ajanta and Ellora caves from Pune with our customized tour packages and cab services. Travel comfortably in spacious vehicles while our knowledgeable drivers assist you with local insights and best route options. Perfect for history enthusiasts and tourists seeking an enriching cultural experience."
    },
    {
        "name": "Pune to Ajanta Caves Taxi",
        "description": "Book a reliable taxi from Pune to Ajanta Caves for a smooth and timely journey. Our fleet includes a range of vehicles to suit your travel needs, all operated by professional drivers who prioritize your safety and comfort. Enjoy a scenic ride with convenient pickups and drop-offs."
    },
    {
        "name": "Pune Airport to Ajanta Ellora Taxi Service",
        "description": "Arriving at Pune Airport? Opt for our taxi service directly from the airport to Ajanta and Ellora caves. Experience prompt pickups, clean and comfortable cars, and professional drivers who will ensure a stress-free transfer to these iconic historical sites."
    },
    {
        "name": "Innova Cab for Ajanta Ellora Caves",
        "description": "Travel in style and comfort with our Innova cab service for your trip to Ajanta and Ellora caves. Spacious interiors, air conditioning, and ample luggage space make this vehicle ideal for family outings or group tours. Our expert drivers ensure timely arrivals and a pleasant travel experience."
    },
    {
        "name": "Pune to Ajanta Ellora Dzire Taxi",
        "description": "Choose our Toyota Dzire taxi for an economical and comfortable trip from Pune to Ajanta and Ellora caves. Perfect for couples or small families, this sedan offers fuel efficiency, air conditioning, and courteous drivers to make your journey smooth and enjoyable."
    },
    {
        "name": "Pune to Ajanta Ellora Tour Cab",
        "description": "Our tour cab services from Pune to Ajanta and Ellora caves include transportation and guided sightseeing options. Customize your itinerary with our flexible packages, travel comfortably with professional drivers, and explore the caves with ease and convenience."
    },
    {
        "name": "Pune to Ajanta Ellora Affordable Taxi",
        "description": "Looking for budget-friendly taxi options for your Ajanta and Ellora caves trip? We offer affordable and reliable taxi services from Pune without compromising on vehicle quality or driver professionalism. Enjoy transparent pricing and comfortable rides on your cultural journey."
    },
    {
        "name": "Pune to Ajanta Ellora Innova Crysta",
        "description": "Experience luxury travel from Pune to Ajanta and Ellora caves with our premium Innova Crysta cab. This vehicle combines elegance, spacious seating, and advanced comfort features. Ideal for families and corporate travelers seeking a first-class journey to these historical marvels."
    }
],
"tableData": [
    ["Pune to Ajanta Caves Cab Service", "Trip to Ajanta Ellora Caves from Pune"],
    ["Pune to Ajanta Caves Taxi", "Pune Airport to Ajanta Ellora Taxi Service"],
    ["Innova Cab for Ajanta Ellora Caves", "Pune to Ajanta Ellora Dzire Taxi"],
    ["Pune to Ajanta Ellora Tour Cab", "Pune to Ajanta Ellora Affordable Taxi"],
    ["Pune to Ajanta Ellora Innova Crysta", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Comprehensive Pune to Ajanta Ellora Tour Package",
        "WhyChoosedescription": "Prince Cabs offers an all-inclusive tour package from Pune to the Ajanta and Ellora caves, combining comfortable travel with expert guidance. This package is designed to make your spiritual and historical journey hassle-free, covering transportation, local sightseeing, and flexible itinerary options tailored to your preferences."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for Extended Travel",
        "WhyChoosedescription": "Our fleet features well-maintained, air-conditioned vehicles equipped with ergonomic seating and ample legroom to ensure your comfort during the long drive. Whether traveling solo, with family, or in a group, our spacious cabs provide a relaxing environment to enjoy the scenic route and breaks along the way."
    },
    {
        "WhyChooseheading": "Experienced Drivers and Knowledgeable Guides",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Ajanta Ellora route and local roads, ensuring safe and timely travel. Additionally, we can arrange knowledgeable guides who provide insightful commentary on the history, architecture, and cultural significance of the caves, enhancing your tour experience."
    },
    {
        "WhyChooseheading": "Flexible Itinerary Tailored to Your Preferences",
        "WhyChoosedescription": "The tour package offers customizable options, allowing you to decide the duration of your visit, the sequence of attractions, and any additional stops. Whether you want a day trip or a multi-day excursion, we adapt the plan to fit your schedule and interests perfectly."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "Prince Cabs follows rigorous cleanliness standards, ensuring all vehicles are sanitized before and after each trip. We maintain high safety standards and regularly service our fleet, prioritizing your health and peace of mind throughout the tour."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our tour packages come with clear and competitive pricing upfront, with no surprise fees. Multiple secure payment options are available, including UPI, credit/debit cards, net banking, and cash, providing convenience and trustworthiness in every transaction."
    },
    {
        "WhyChooseheading": "Dedicated Customer Support for a Seamless Experience",
        "WhyChoosedescription": "Our customer support team is available 24/7 to assist with booking, itinerary adjustments, or any questions you may have before and during your tour. We are committed to making your Pune to Ajanta Ellora tour memorable, enjoyable, and hassle-free."
    }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer a Pune to Ajanta Ellora tour package?',
        answer: 'Yes, Prince Cabs offers a specially curated Pune to Ajanta Ellora tour package, covering major historical sites like Ajanta Caves, Ellora Caves, and Daulatabad Fort.',
    },
    {
        question: 'What does the Pune to Ajanta Ellora tour package include?',
        answer: 'The package includes cab service, driver allowance, tolls, and parking charges. It can be customized to include sightseeing, hotel stays, and multi-day itineraries.',
    },
    {
        question: 'What types of vehicles are available for the Ajanta Ellora tour?',
        answer: 'We offer a wide range of vehicles including sedans, SUVs, and tempo travellers to accommodate solo travelers, families, and groups comfortably.',
    },
    {
        question: 'Can I customize the itinerary for the Ajanta Ellora tour?',
        answer: 'Absolutely! You can choose the number of days, tourist spots, stopovers, and even hotel preferences. Our team will help you plan the perfect itinerary.',
    },
    {
        question: 'How long does the Pune to Ajanta Ellora tour take?',
        answer: 'The tour typically takes 2 to 3 days, depending on the sites you want to cover and the travel pace. One-day options are also available with limited stops.',
    },
    {
        question: 'What are the charges for the Ajanta Ellora tour package from Pune?',
        answer: 'Pricing varies based on vehicle type, duration, and itinerary. Contact Prince Cabs for a detailed and customized quote for your tour.',
    },
    {
        question: 'Are the cabs comfortable and safe for long-distance sightseeing?',
        answer: 'Yes, our cabs are air-conditioned, sanitized, and maintained regularly. Drivers are experienced and familiar with tourist routes for a smooth experience.',
    },
];

const testimonials = [
    {
        name: "Mr. Harshal Patankar",
        position: "History Buff",
        text: "The Ajanta Ellora tour from Pune was beautifully organized by Prince Cabs. Our driver was friendly, and the vehicle was perfect for our 3-day trip.",
        image: "/img/testimonial/testimonial-thumb-ajantaellora-1.png",
    },
    {
        name: "Ms. Vaishnavi Khedekar",
        position: "Weekend Explorer",
        text: "Prince Cabs gave us a well-planned and comfortable Ajanta Ellora tour from Pune. It was an unforgettable experience with excellent service.",
        image: "/img/testimonial/testimonial-thumb-ajantaellora-2.png",
    },
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ajanta Ellora Tour Package",
  "image": "https://princecab.com/assets/images/pune-ajanta-ellora-tour.jpg",
  "description": "Book Pune to Ajanta Ellora tour package with Prince Cabs. Comfortable Innova, Dzire, and Etios taxis available for trips to Ajanta Caves and Ellora Caves. Affordable, reliable, and perfect for family tours. 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7500",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-ajanta-ellora-tour-package"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Ajanta Ellora Tour Package | Comfortable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Ajanta Ellora tour packages with reliable Innova, Dzire, and Etios cabs. Perfect for Ajanta and Ellora Caves trips, family tours, and airport pickups. Book online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Ajanta Caves Cab Service, Trip to Ajanta Ellora Caves from Pune, Pune to Ajanta Caves Taxi, Pune Airport to Ajanta Ellora Taxi Service, Innova Cab for Ajanta Ellora Caves, Pune to Ajanta Ellora Dzire Taxi, Pune to Ajanta Ellora Tour Cab, Pune to Ajanta Ellora Affordable Taxi, Pune to Ajanta Ellora Innova Crysta"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoajantaellora;